import { Component, OnInit } from '@angular/core';
import { CustomizationManager } from '@core/services/customization-manager.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(
    private CustomizationManager: CustomizationManager
  ) { }

  ngOnInit() { }
}
